import { Box, Flex } from '@chakra-ui/react';

import { Divider } from 'uiToolkitV1/Divider';
import { TextBodyMedium, TextLabel } from 'uiToolkitV1/Typography';

const ModuleItem = ({ title, description, component }) => (
  <Box>
    <Flex p="1rem" justifyContent="space-between" alignItems="center">
      <Box width="75%">
        <TextBodyMedium>{title}</TextBodyMedium>
        <TextLabel color="text.g2">{description}</TextLabel>
      </Box>
      <Box>{component}</Box>
    </Flex>
    <Divider />
  </Box>
);

export default ModuleItem;
